import React from 'react'
import {Header, List} from 'semantic-ui-react'

const AddResourceParameters = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Add Resource Parameters</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version/environment you would like to work with.</List.Item>
        <List.Item>2. Click the "Add Resource" button.</List.Item>
        <List.Item>3. Set the Verb to GET </List.Item>
        <List.Item>4. Set the path to /customers/{'{id}'} </List.Item>
        <List.Item>5. Click the "Add" button</List.Item>
        <List.Item>6. Click "Add Response" and add a response for this resource.</List.Item>
        <List.Item>7. Issue a request to GET /customers/123</List.Item>
        <List.Item>8. Navigate to the "Logs" tab for this resource</List.Item>
        <List.Item>9. You should see the log for this request along with a req object containing params object of {'{"id":"123"}'}</List.Item>
      </List>
    </div>
  )
}

export {AddResourceParameters}

export default AddResourceParameters